import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { FiTrash2, FiChevronDown, FiChevronUp, FiSearch } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import ProviderDetails from './ProviderDetails';
import { transliterate } from 'transliteration';


// Styled Components
const Container = styled.div`
  padding: 4rem 2rem;
  margin-bottom: 100px;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 2rem;

  h2 {
    color: #385963;
  }
`;

const SearchBar = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 3rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 0.5rem 1rem;

  input {
    border: none;
    flex: 1;
    font-size: 1rem;
    outline: none;
    color: #385963;
  }

  svg {
    margin-right: 0.5rem;
    color: #555;
  }

  
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);

  th, td {
    padding: 1rem;
    text-align: left;
    border-bottom: 1px solid #eee;
    color: #385963;
  }

  th {
    background-color: #f9f9f9;
  }

  td:last-child {
    text-align: right;
  }

  button {
    background: none;
    border: none;
    color: #e74c3c;
    cursor: pointer;
    font-size: 1.2rem;
  }

  button:hover {
    color: #c0392b;
  }
`;

const ToggleButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  margin-left: 0.5rem;
`;

const DetailsContainer = styled.div`
  padding: 1rem;
  background-color: #f0f4f8;
  text-align: left;
  border-radius: 5px;
`;

// FilePlaceTypeEnum
const RoleEnums = {
  RegisteredUser : 0 ,
  Provider : 1,
  Admin : 2,
  PreApprovedProvider : 3,
};



// Main Component
const ManageProviders = () => {

  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { i18n, t } = useTranslation();
  const [providers, setProviders] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedRow, setExpandedRow] = useState(null);
  const tokenString = sessionStorage.getItem("token") ;

  useEffect(() => {
  const fetchProviders = async () => {
    const active = true;
    const role = RoleEnums.Provider;
    const requestBody = { role , active };

      try {
        const response = await fetch(
          `${BASE_URL}User/search`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${tokenString}` 
            },
             body: JSON.stringify(requestBody),
          }
        );
        
         const data = await response.json();  
         setProviders(data);

         if (!response.ok) {
           throw new Error(`HTTP error! status: ${response.status}`);
         }
   
      } catch (error) {
        console.error('Error deleting destination:', error);
      }
    };

    fetchProviders();
  }, []);
  

  const handleDelete = (id) => {
    if (window.confirm(t('confirmDeactivateProvider'))) {
      setProviders((prev) => prev.filter((p) => p.id !== id));
    
    const deleteUser = async () => {
      try {
        const response = await fetch(`${BASE_URL}User/${id}/deactivate`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${tokenString}` 
            }
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

      } catch (error) {
        console.error('Error DEACTIVATING user:', error);     
      }
    };

    deleteUser();
   }
};

  return (
    <Container>
      <Header>
        <h2>{t('manageProviders')}</h2>
      </Header>

      <SearchBar>
        <FiSearch />
        <input
          type="text"
          placeholder={t('searchProviderText')}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </SearchBar>

      <Table>
        <thead>
          <tr>
            <th>{t('fullname')}</th>
            <th>{t('email')}</th>
            {/* <th>{t('phone')}</th> */}
            <th>{t('actions')}</th>
          </tr>
        </thead>
        <tbody>
          {providers.length > 0 ? (
            providers.map((provider) => (
              <React.Fragment key={provider.id}>
                <tr>
                  <td>{provider.name}</td>
                  <td>{provider.email}</td>
                  <td style={{ textAlign: 'right' }}>
                    <ToggleButton onClick={() => setExpandedRow(expandedRow === provider.id ? null : provider.id)}>
                      {expandedRow === provider.id ? <FiChevronUp /> : <FiChevronDown />}
                    </ToggleButton>
                    <ToggleButton onClick={() => handleDelete(provider.id)}>
                      <FiTrash2 />
                    </ToggleButton>
                  </td>
                </tr>
                {expandedRow === provider.id && (
                  <tr>
                    <td colSpan="4">
                      <ProviderDetails provider={provider} />
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))
          ) : (
            <tr>
              <td colSpan="4">{t('noProvidersFound')}</td>
            </tr>
          )}
        </tbody>
      </Table>
    </Container>
  );
};

export default ManageProviders;
